import { useEffect, useImperativeHandle, useMemo, useRef, useState } from "react"
import styles from './index.module.scss'
import { forwardRef } from "react"
import * as _ from "underscore";
import Iconfont from '@utils/Iconfont';
import Utils from "@utils/utils"
import ImageRenderBox from "../ImageRenderBox";
import { useDrag, useDrop, useDragLayer } from 'react-dnd';
import { Image } from "antd";

const ImageItem = (props) => {
    const { index, actived } = props
    const canDrag = useMemo(() => {
        return !actived
    }, [actived])
    const [{ isDragging }, drag, preview] = useDrag({
        type: 'DragDropReplaceBox',
        item: { index },
        end: (item, monitor) => {},
        isDragging: (monitor) => {
            return index === monitor.getItem().index;
        },
        canDrag: () => canDrag,
        collect: (monitor) => ({
            isDragging: monitor.isDragging(),
        }),
    })

    const ref = useRef()
    useEffect(() => {
        if (actived) {
            ref.current?.scrollIntoView({
                behavior: "smooth",
            })
        }
    }, [actived, props.scrollDelay])

    return (
        <div
            ref={drag(ref)}
            className={`${styles.ImageItem} ${actived && styles.actived}`}
        >
            <Image src={Utils.getImgThumbnail(props.src)} preview={false} fallback={props.src} />
        </div>
    )
}

const ImagePreviewRender = forwardRef((props, ref) => {
    useImperativeHandle(ref, () => ({
        goPrevious: handlePrevious,
        goNext: handleNext,
    }))
    // 记录index
    const [dispalySpuId, setDispalySpuId] = useState()
    const [dispalyIndexList, setDispalyIndexList] = useState([])

    // 初始化
    useEffect(() => {
        const currentIndex = props.currentIndex
        const currentItem = props.imageItems[currentIndex] || props.imageItems[0]
        if (!currentItem) return

        const dispalySpuId = currentItem.spuId
        const displayImageItems = props.imageItems.filter(item => item.spuId == dispalySpuId)
        const index = displayImageItems.findIndex(item => item.imageId == currentItem.imageId)

        setDispalySpuId(dispalySpuId)
        if (index == 0) setDispalyIndexList([index, index+1, index+2])
        else if (index == displayImageItems.length - 1) setDispalyIndexList([index-2, index-1, index])
        else setDispalyIndexList([index-1, index, index+1])
    }, [])
    // 取代props.imageItems
    const displayImageItems = useMemo(() => {        
        return props.imageItems.filter(item => item.spuId == dispalySpuId)
    }, [props.imageItems, dispalySpuId])
    // 显示的imageItem
    const dispalyList = useMemo(() => {
        return dispalyIndexList.map(index => displayImageItems[index]||null)
    }, [displayImageItems, dispalyIndexList])
    // 可以切换的imageItems，过滤掉锚定，仅在当前spu内过滤
    const availableImageItems = useMemo(() => {
        return displayImageItems.filter((item, index) => !(dispalyIndexList.includes(index) && item.fixed))
    }, [displayImageItems, dispalyIndexList])
    // 设置current
    useEffect(() => {
        // 按实际顺序进行排序，以下方预览图的排序为准
        const nofixedAndsortedList = dispalyList.filter(item => !!item && !item.fixed).sort((a,b)=>a.index-b.index)
        if (nofixedAndsortedList.length == 0) return
        // 以最左侧第一张未被钉住的图片作为基准
        const leftItem = nofixedAndsortedList[0]
        const leftItemIndex = availableImageItems.findIndex(item => item.imageId == leftItem.imageId)
        // 设置current，决定了pre/next按钮的是否可切换
        if (leftItemIndex == 0) { // 切换到最左侧，current取第一个元素
            props.onCurrentChange(props.imageItems[0], dispalyList.map(item => item ? item.index : -1))
        } else if (leftItemIndex == availableImageItems.length - 1) { // 切换到最右侧，current取最后一个元素
            props.onCurrentChange(props.imageItems[props.imageItems.length - 1], dispalyList.map(item => item ? item.index : -1))
        } else { // 否则current取leftItem
            props.onCurrentChange(leftItem, dispalyList.map(item => item ? item.index : -1))
        }
    }, [props.imageItems, dispalyList])

    const handlePrevious = () => {
        console.log('上一组')
        // 按实际顺序进行排序，以下方预览图的排序为准
        const nofixedAndsortedList = dispalyList.filter(item => !item || !item.fixed).sort((a,b)=> {
            if (!a && !b) return 0; // 两个都是 null，保持原顺序
            if (!a) return 1; // a 是 null，排到后面
            if (!b) return -1; // b 是 null，排到后面
            return a.index - b.index
        })
        // 每组切换的数量
        const len = nofixedAndsortedList.length
        // 以最左侧第一张未被钉住的图片作为基准
        const leftItem = nofixedAndsortedList[0]
        const leftItemIndex = leftItem ? availableImageItems.findIndex(item => item.imageId == leftItem.imageId) : len
        // 向左切换对应数量的图片
        let nextList = availableImageItems.slice(leftItemIndex - len, leftItemIndex)
        // 切换到队首，数量不足时，取前len个元素
        if (nextList.length < len) nextList = availableImageItems.slice(0, len)
        // 通过修改dispalyIndexList，将切换后的元素回填到dispalyList
        setDispalyIndexList(pre => {
            const temp = [...pre]
            let index = 0
            for (let i = 0; i < temp.length; i++) {
                const _index = temp[i]
                const item = displayImageItems[_index]||null
                if (item?.fixed) continue
                const nextItem = nextList[index++]
                temp[i] = nextItem ? displayImageItems.findIndex(item => item.imageId == nextItem.imageId) : -1
            }
            return temp
        })
    }

    const handleNext = () => {
        console.log('下一组')
        // 按实际顺序进行排序，以下方预览图的排序为准
        const nofixedAndsortedList = dispalyList.filter(item => !item || !item.fixed).sort((a,b)=> {
            if (!a && !b) return 0; // 两个都是 null，保持原顺序
            if (!a) return 1; // a 是 null，排到后面
            if (!b) return -1; // b 是 null，排到后面
            return a.index - b.index
        })
        // 每组切换的数量
        const len = nofixedAndsortedList.length
        // 以最左侧第一张未被钉住的图片作为基准
        const leftItem = nofixedAndsortedList[0]
        const leftItemIndex = leftItem ? availableImageItems.findIndex(item => item.imageId == leftItem.imageId) : -len
        // 向右切换对应数量的图片
        let nextList = availableImageItems.slice(leftItemIndex + len, leftItemIndex + len*2)
        // 切换到队尾，数量不足时，取最后len个元素
        if (nextList.length < len) nextList = availableImageItems.slice(-len)
        // 通过修改dispalyIndexList，将切换后的元素回填到dispalyList
        setDispalyIndexList(pre => {
            const temp = [...pre]
            let index = 0
            for (let i = 0; i < temp.length; i++) {
                const _index = temp[i]
                const item = displayImageItems[_index]||null
                if (item?.fixed) continue
                const nextItem = nextList[index++]
                temp[i] = nextItem ? displayImageItems.findIndex(item => item.imageId == nextItem.imageId) : -1
            }
            return temp
        })
    }

    const handleSwap = (from, to) => {
        setDispalyIndexList(pre => {
            const temp = [...pre]
            const tempItem = temp[from]
            temp[from] = temp[to]
            temp[to] = tempItem
            return [...temp]
        })
    }

    const handleReplace = (from, to) => {
        setDispalyIndexList(pre => {
            const temp = [...pre]
            temp[to] = from
            return [...temp]
        })
    }

    return (
        <div className={styles.ImagePreviewRender}>
            <div className={styles.ImageBox}>
            {
                dispalyList.map((item, index) => (
                    <ImageRenderBox
                        key={item?.imageId||index}
                        item={item}
                        index={index}
                        fixedable={true} // 可固定
                        canDrag={true}
                        canSwapDrop={true}
                        canReplaceDrop={!item?.fixed}
                        onLabel={item?.onLabel}
                        onSwap={handleSwap}
                        onReplace={handleReplace}
                        onFixed={() => props.onFixed(item?.imageId)}
                        downloadable={item?.downloadable}
                    />
                ))
            }
            </div>
            <div className={styles.BottomBox}>
                <div className={styles.ImageListBox}>
                    <div className={`${styles.MultipleTrigger} ${styles.Single}`} onClick={() => props.onMultiple(false)}>
                        <div></div>
                        <span>验收单张</span>
                    </div>
                    <div className={styles.ImageList}>
                    {
                        displayImageItems.map((item, index) => (
                            <ImageItem
                                key={item.imageId}
                                index={index}
                                actived={dispalyList.find(i => i?.imageId == item.imageId)}
                                src={/\.mp4/.test(item.url) ? Utils.getVideoSnapshot(item.url) : item.url}
                            />
                        ))
                    }
                    </div>
                </div>
            </div>           
        </div>
    )
})

export default ImagePreviewRender